import gql from 'graphql-tag'

export const DELETE_SCHEDULER = gql`
  mutation delete_scheduler($input: Id) {
    delete_scheduler(input: $input)
      @rest(type: "Scheduler", path: "/delete-scheduler", bodyKey: "input", method: "POST")
  }
`
